import { useCallback, useEffect, useRef } from "react";

export default function useBullseyeDisplayRotation({ matchId, sections, sectionKey, manual, intervalMs, setSectionKey }) {
  const reachedEnd = useRef(false);
  // Score polling replaces section objects; only a changed section sequence resets rotation.
  const sectionKeysJSON = JSON.stringify([
    "",
    ...new Set(sections.map((section) => section.key).filter((key) => key && key !== "match::aggregate")),
  ]);

  useEffect(() => {
    reachedEnd.current = false;
  }, [matchId, sectionKey, sectionKeysJSON, manual]);

  const onReachedEnd = useCallback(() => {
    reachedEnd.current = true;
  }, []);

  useEffect(() => {
    const keys = JSON.parse(sectionKeysJSON);
    if (manual || keys.length < 2) return undefined;

    const timer = window.setInterval(() => {
      if (!reachedEnd.current) return;
      reachedEnd.current = false;
      setSectionKey((current) => keys[(keys.indexOf(current) + 1) % keys.length]);
    }, intervalMs);
    return () => window.clearInterval(timer);
  }, [matchId, sectionKeysJSON, manual, intervalMs, setSectionKey]);

  return onReachedEnd;
}
